let directory, directoryLoader;
let loadDirectoryAccess = false;

$(document).ready(function () {
    directory = $(".directoryRow");
    directoryLoader = $(".directoryLoader");
    if (directory.length) {
        if (directory.data('load-more') == true) {
            loadDirectoryAccess = true;
            // checkloadMoreDirectory();
            



        }
    };
});

function checkloadMoreDirectory() {
    if (loadDirectoryAccess && $(window).scrollTop() + window_height > directory.offset().top + directory.innerHeight() * 0.75) {
        loadDirectoryAccess = false;
        directoryLoader.show();
        $(window).off('scroll.directory');
        getloadMoreDirectory();
        //directoryLoader.show();
        //console.log('getloadMoreDirectory...')
    };
};

$(window).on('scroll.directory', checkloadMoreDirectory);

function getloadMoreDirectory() {
    // const page = directory.data('page-load');
    // const type = directory.data('type');
    // const testJson = directory.data('test-json');
    // loadMoreDirectory({ page, type, testJson });

    const page = directory.attr('data-page-load');
    const type = directory.attr('data-type');
    const parent = directory.attr('data-parent');
    const testJson = directory.attr('data-test-json');
    const search = $(".searchForm input[name=text]").val();
    loadMoreDirectory({ page, type, testJson, parent, search });
    //directoryLoader.hide();
    setTimeout(function(){
        directoryLoader.hide();
    }, 500);      

};

function loadMoreDirectoryAction({ success, nextPage, loadMore, list }) {
    if (success) {
        //directoryLoader.hide();
        setTimeout(function(){
            directoryLoader.hide();
        }, 500);  
        const html = list.reduce((sum, element) => sum + createDirectoryItem(element), '');
        directory.append(html).find(".directoryItem.ajax").fadeTo(animTime, 1).removeClass("ajax");
        directory.attr("data-page-load", nextPage);
        directory.attr("data-load-more", loadMore);
        // loadMore scroll
        if (loadMore) {
            loadDirectoryAccess = true;
            $(window).on('scroll.directory', checkloadMoreDirectory);
            //directoryLoader.hide();
            setTimeout(function(){
                directoryLoader.hide();
            }, 500);  
        }
        //directoryLoader.hide();
        setTimeout(function(){
            directoryLoader.hide();
        }, 500);  
    };
};

function createDirectoryItem({ title, type, link, flag, site, price, viewProfile }) {
    return `<div class="directoryItem ${type} w33 ajax">
        <a href="${link}">
            <h4 class="line_hover">${title}</h4>
            ${flag ? `<img src="${flag.src}" alt="${flag.alt}" class="flag">` : ''}
            <div class="bottom">
            ${site ? `<div class="site">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M0 10C0 4.47676 4.47639 0 10 0C15.5232 0 20 4.47639 20 10C20 15.5232 15.5236 20 10 20C4.47676 20 0 15.5236 0 10ZM1 10C1 14.9713 5.02903 19 10 19C14.9713 19 19 14.971 19 10C19 5.02869 14.971 1 10 1C5.02869 1 1 5.02903 1 10ZM5.5 10.5H9.5V14.5C9.5 15.1667 10.5 15.1667 10.5 14.5V10.5H14.5C15.1667 10.5 15.1667 9.5 14.5 9.5H10.5V5.5C10.5 4.83333 9.5 4.83333 9.5 5.5V9.5H5.5C4.83333 9.5 4.83333 10.5 5.5 10.5Z"
                    fill="#292F48" />
            </svg>
            <p>${site}</p>
            </div>` : ''}
            ${price ? `<div class="site no-plus">
            <p>${price}</p>
            </div>` : ''}
            ${viewProfile ? `<div class="viewProfile"><p>${viewProfile}</p></div>` : ''}       
            </div>
        </a>
    </div>`;
};
